import React from "react";
import {
  Box,
  TextField,
  IconButton,
  Tooltip,
  Button,
  Alert
} from "@mui/material";
import {
  Search,
  Refresh,
  FileDownload,
  Print
} from "@mui/icons-material";

const ExpedicaoFilters = ({
  searchTerm,
  setSearchTerm,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  loading,
  onRefresh,
  onExport,
  onPrint
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderBottom: "1px solid rgba(0,0,0,0.1)",
      }}
    >
      <Alert 
        severity="info" 
        sx={{ 
          mb: 0,
          borderRadius: 0,
          backgroundColor: "rgba(33, 150, 243, 0.08)",
          "& .MuiAlert-icon": {
            color: "#2196f3"
          }
        }}
      >
        Exibindo dados de etiquetas de transporte ainda não impressas no período selecionado
      </Alert>
      
      <Box
        sx={{
          p: 3,
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2
        }}
      >
      <Box sx={{ flex: "1 1 300px", minWidth: 200 }}>
        <TextField
          fullWidth
          placeholder="Buscar SKU ou Produto"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: <Search sx={{ mr: 1, color: "#666" }} />
          }}
        />
      </Box>
      
      <Box sx={{ flex: "1 1 120px", minWidth: 120 }}>
        <TextField
          label="Data Início"
          type="date"
          size="small"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />
      </Box>
      
      <Box sx={{ flex: "1 1 120px", minWidth: 120 }}>
        <TextField
          label="Data Fim"
          type="date"
          size="small"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />
      </Box>
      
      <Box sx={{ display: "flex", gap: 1, flex: "0 0 auto" }}>
        <Tooltip title="Atualizar">
          <IconButton 
            onClick={onRefresh} 
            disabled={loading}
            sx={{ 
              backgroundColor: "#f5f5f5",
              "&:hover": { backgroundColor: "#e0e0e0" }
            }}
          >
            <Refresh />
          </IconButton>
        </Tooltip>
        
        <Button
          variant="outlined"
          size="small"
          startIcon={<FileDownload />}
          onClick={onExport}
          sx={{ 
            borderColor: "#FF7322",
            color: "#FF7322",
            transition: "all 0.3s ease",
            "&:hover": { 
              borderColor: "#e6651e",
              backgroundColor: "rgba(255, 115, 34, 0.04)",
              transform: "translateY(-1px)",
              boxShadow: "0 2px 8px rgba(255, 115, 34, 0.3)"
            }
          }}
        >
          Exportar
        </Button>
        
        <Button
          variant="contained"
          size="small"
          startIcon={<Print />}
          onClick={onPrint}
          sx={{ 
            backgroundColor: "#FF7322",
            transition: "all 0.3s ease",
            boxShadow: "0 2px 4px rgba(255, 115, 34, 0.3)",
            "&:hover": { 
              backgroundColor: "#e6651e",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 12px rgba(255, 115, 34, 0.4)"
            }
          }}
        >
          Imprimir
        </Button>
      </Box>
      </Box>
    </Box>
  );
};

export default ExpedicaoFilters;